// src/authConfig.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { createNestablePublicClientApplication, LogLevel } from "@azure/msal-browser";
// src/Errors.ts
var ErrorCodesEnum = /* @__PURE__ */ function(ErrorCodesEnum2) {
    ErrorCodesEnum2[ErrorCodesEnum2["DEFAULT"] = 0] = "DEFAULT";
    ErrorCodesEnum2[ErrorCodesEnum2["NO_CREDENTIALS"] = 1] = "NO_CREDENTIALS";
    ErrorCodesEnum2[ErrorCodesEnum2["NO_HEADERS"] = 2] = "NO_HEADERS";
    ErrorCodesEnum2[ErrorCodesEnum2["INVALID_CREDENTIALS"] = 3] = "INVALID_CREDENTIALS";
    ErrorCodesEnum2[ErrorCodesEnum2["INVALID_REGISTRATION"] = 4] = "INVALID_REGISTRATION";
    ErrorCodesEnum2[ErrorCodesEnum2["NO_EMAIL_FOUND"] = 5] = "NO_EMAIL_FOUND";
    ErrorCodesEnum2[ErrorCodesEnum2["USE_CUSTOM_ERROR"] = 6] = "USE_CUSTOM_ERROR";
    return ErrorCodesEnum2;
}(ErrorCodesEnum || {});
var GraphResponseError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(_GraphResponseError, Error1);
    function _GraphResponseError(response, message, responseBody) {
        _class_call_check(this, _GraphResponseError);
        var _this;
        _this = _call_super(this, _GraphResponseError, [
            "Calling ".concat(response.url, " resulted in error code ").concat(response.status, ": ").concat(response.statusText) + (message ? "\n" + message : "") + (responseBody ? "\nBody: " + responseBody : "")
        ]);
        _this.name = _GraphResponseError.name;
        Object.setPrototypeOf(_this, _GraphResponseError.prototype);
        return _this;
    }
    return _GraphResponseError;
}(_wrap_native_super(Error));
var InvalidStateError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(_InvalidStateError, Error1);
    function _InvalidStateError(message) {
        _class_call_check(this, _InvalidStateError);
        var _this;
        _this = _call_super(this, _InvalidStateError, [
            message
        ]);
        _this.name = _InvalidStateError.name;
        Object.setPrototypeOf(_this, _InvalidStateError.prototype);
        return _this;
    }
    return _InvalidStateError;
}(_wrap_native_super(Error));
var InvalidArgumentError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(_InvalidArgumentError, Error1);
    function _InvalidArgumentError(message) {
        _class_call_check(this, _InvalidArgumentError);
        var _this;
        _this = _call_super(this, _InvalidArgumentError, [
            message
        ]);
        _this.name = _InvalidArgumentError.name;
        Object.setPrototypeOf(_this, _InvalidArgumentError.prototype);
        return _this;
    }
    return _InvalidArgumentError;
}(_wrap_native_super(Error));
var TimeoutError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(_TimeoutError, Error1);
    function _TimeoutError(message) {
        _class_call_check(this, _TimeoutError);
        var _this;
        _this = _call_super(this, _TimeoutError, [
            message
        ]);
        _this.name = InvalidStateError.name;
        Object.setPrototypeOf(_this, _TimeoutError.prototype);
        return _this;
    }
    return _TimeoutError;
}(_wrap_native_super(Error));
// src/Shared.ts
var Helpers = /*#__PURE__*/ function() {
    "use strict";
    function Helpers() {
        _class_call_check(this, Helpers);
    }
    _create_class(Helpers, [
        {
            key: "encodeHtml",
            value: function encodeHtml(text) {
                return String(text).replace(/[&<>"'\/]/g, function(s) {
                    return ({
                        "&": "&amp;",
                        "<": "&lt;",
                        ">": "&gt;",
                        '"': "&quot;",
                        "'": "&#39;",
                        "/": "&#x2F;"
                    })[s];
                });
            }
        },
        {
            // Unicode to ASCII (encode data to Base64)
            key: "encodeToBase64",
            value: function encodeToBase64(data) {
                try {
                    return btoa(unescape(encodeURIComponent(data)).replace(/\\"/g, '"').replace(/&lt;/g, "<").replace(/&gt;/g, ">"));
                } catch (e) {
                    return null;
                }
            }
        },
        {
            // Exchange uses left and right double quotes because regular quotes get interpreted
            key: "cleanQuotes",
            value: function cleanQuotes(text) {
                return text.replace(/\\[“"”]/g, '"');
            }
        },
        {
            key: "isShared",
            value: function isShared() {
                var _Office_context_mailbox_item;
                return typeof ((_Office_context_mailbox_item = Office.context.mailbox.item) === null || _Office_context_mailbox_item === void 0 ? void 0 : _Office_context_mailbox_item.getSharedPropertiesAsync) === "function" === true;
            }
        }
    ], [
        {
            key: "isIE11",
            get: function get() {
                var _navigator_userAgent, _navigator, _navigator_userAgent1, _navigator1;
                return ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator_userAgent = _navigator.userAgent) === null || _navigator_userAgent === void 0 ? void 0 : _navigator_userAgent.includes("Trident/")) || ((_navigator1 = navigator) === null || _navigator1 === void 0 ? void 0 : (_navigator_userAgent1 = _navigator1.userAgent) === null || _navigator_userAgent1 === void 0 ? void 0 : _navigator_userAgent1.includes("MSIE"));
            }
        }
    ]);
    return Helpers;
}();
var AsyncTimer = /*#__PURE__*/ function() {
    "use strict";
    function _AsyncTimer() {
        _class_call_check(this, _AsyncTimer);
    }
    _create_class(_AsyncTimer, [
        {
            key: "start",
            value: function start(ms, fn) {
                var errorMessage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Method timed out";
                return new Promise(function(resolve, reject) {
                    return _async_to_generator(function() {
                        var id, res;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    id = setTimeout(function() {
                                        return reject(new TimeoutError(errorMessage));
                                    }, ms);
                                    return [
                                        4,
                                        fn()
                                    ];
                                case 1:
                                    res = _state.sent();
                                    if (id) {
                                        window.clearTimeout(id);
                                    }
                                    resolve(res);
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                });
            }
        }
    ], [
        {
            key: "executeWithTimeout",
            value: function executeWithTimeout(ms, fn) {
                var timer = new _AsyncTimer();
                return timer.start(ms, fn);
            }
        }
    ]);
    return _AsyncTimer;
}();
// src/JSLog.ts
function parseStackTrace(stack, errorLog) {
    var response = {
        callerFunction: "<anonymous>",
        callerFile: "",
        lineNumber: 0,
        lineColumn: 0,
        stack: stack
    };
    if (!stack) {
        return response;
    }
    try {
        var stackLines = stack.split("\n");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = stackLines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var stackLine = _step.value;
                if (!stackLine) {
                    continue;
                }
                var lowerLine = stackLine.toLowerCase();
                if (lowerLine.includes("jslog") && !lowerLine.includes(".spec")) {
                    continue;
                }
                var lineMatch = /\s+at\s+(?:([\w\.]*?)\s+)?\(?(.*?):(\d+):(\d+)\)?/.exec(stackLine);
                if (!lineMatch || lineMatch.length < 2) {
                    continue;
                }
                if (lineMatch[2] && lineMatch[3] && lineMatch[4]) {
                    response.callerFunction = lineMatch[1] || "<anonymous>";
                    response.callerFile = lineMatch[2];
                    response.lineNumber = +lineMatch[3];
                    response.lineColumn = +lineMatch[4];
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        response.stack = cleanStackTrace(stack);
    } catch (err) {
        errorLog("Error parsing stack trace", err);
    }
    return response;
}
function cleanStackTrace(stack) {
    return stack.replace(/(?:[a-zA-Z]:)?(?:\\|\/)[^\s:]+(?:\\|\/)([^\\\/\s:]+):(\d+:\d+)/g, "$1:$2");
}
var JSLog = function() {
    var originalConsole = window.console;
    var originalConsoleError = originalConsole.error;
    function safeConsoleError(arg1, arg2) {
        if (arg2) {
            originalConsoleError.call(originalConsole, arg1, arg2);
        } else {
            originalConsoleError.call(originalConsole, arg1);
        }
    }
    var _customProps = {}, _url = "/o365/js", _headers = {};
    function report(message, error, severity) {
        return _async_to_generator(function() {
            var payload, errorTypeName, testError, errorStack, stack, payloadJson, response, responseText, err, err1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        payload = {};
                        try {
                            errorTypeName = (error === null || error === void 0 ? void 0 : error.name) || null;
                            if (error) {
                                severity = "error";
                            }
                            if (error && !message) {
                                message = error.message;
                            }
                            testError = error || new Error();
                            errorStack = testError.stack || testError.backtrace || testError.stacktrace;
                            stack = parseStackTrace(errorStack, console.error);
                            payload = {
                                url: window.location.href,
                                userAgent: navigator.userAgent,
                                language: navigator.language || navigator.userLanguage,
                                severity: severity,
                                name: errorTypeName,
                                message: message,
                                file: stack.callerFile,
                                method: stack.callerFunction,
                                lineNumber: stack.lineNumber,
                                lineColumn: stack.lineColumn,
                                customProps: _customProps,
                                stacktrace: error ? errorStack : null
                            };
                        } catch (err) {
                            try {
                                safeConsoleError("Unable to generate payload for JS error report", err);
                                safeConsoleError(payload);
                            } catch (err2) {}
                            return [
                                2,
                                false
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            ,
                            9
                        ]);
                        payloadJson = JSON.stringify(payload);
                        return [
                            4,
                            AsyncTimer.executeWithTimeout(1e3, function() {
                                return _async_to_generator(function() {
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    fetch(_url, {
                                                        method: "POST",
                                                        headers: _object_spread({
                                                            "Content-Type": "application/json;charset=UTF-8"
                                                        }, _headers),
                                                        body: payloadJson
                                                    })
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!!response.ok) return [
                            3,
                            7
                        ];
                        responseText = "";
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            response.text()
                        ];
                    case 4:
                        responseText = _state.sent();
                        safeConsoleError("Failed to send log to ".concat(_url, ": ").concat(response.status, " - ").concat(response.statusText, "; body: ").concat(responseText));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        safeConsoleError("Unable to read fetch response text", err);
                        safeConsoleError("Failed to send log to ".concat(_url, ": ").concat(response.status, " - ").concat(response.statusText));
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2,
                            false
                        ];
                    case 7:
                        return [
                            2,
                            true
                        ];
                    case 8:
                        err1 = _state.sent();
                        try {
                            safeConsoleError("Unable to send JS error report", err1);
                        } catch (err2) {}
                        return [
                            2,
                            false
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return {
        error: function JSLogError(message, ex) {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                report(message, ex || null, "error")
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            })();
        },
        warn: function JSLogWarn(message) {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                report(message, null, "warning")
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            })();
        },
        notify: function JSLogNotify(message, severity) {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                report(message, null, severity || "information")
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            })();
        },
        set: function JSLogSet(prop, val) {
            if (prop && typeof prop === "string") {
                _customProps[prop] = val === null || typeof val === "undefined" ? null : val.toString();
            }
        },
        init: function JSLogInit(args) {
            _url = (args === null || args === void 0 ? void 0 : args.url) || "/o365/js";
            _headers = (args === null || args === void 0 ? void 0 : args.headers) || {};
            _customProps = {};
        }
    };
}();
// src/authConfig.ts
var AccountManager = /*#__PURE__*/ function() {
    "use strict";
    function AccountManager(appId, authority) {
        _class_call_check(this, AccountManager);
        this.appId = appId;
        this.clientApp = void 0;
        this.account = void 0;
        this.loginHint = void 0;
        this.tokens = {};
        this.authority = authority || "https://login.microsoftonline.com/common";
    }
    _create_class(AccountManager, [
        {
            key: "getMsalConfig",
            value: function getMsalConfig(enableDebugLogging) {
                var msalConfig = {
                    auth: {
                        clientId: this.appId,
                        authority: this.authority
                    },
                    system: {}
                };
                if (enableDebugLogging) {
                    msalConfig.system.loggerOptions = {
                        logLevel: LogLevel.Verbose,
                        loggerCallback: function(level, message) {
                            JSLog.notify(message);
                            switch(level){
                                case LogLevel.Error:
                                    console.error(message);
                                    return;
                                case LogLevel.Info:
                                    console.info(message);
                                    return;
                                case LogLevel.Verbose:
                                    console.debug(message);
                                    return;
                                case LogLevel.Warning:
                                    console.warn(message);
                                    return;
                            }
                        },
                        piiLoggingEnabled: true
                    };
                } else {
                    msalConfig.system.loggerOptions = {
                        logLevel: LogLevel.Warning,
                        loggerCallback: function(level, message) {
                            JSLog.notify(message);
                            switch(level){
                                case LogLevel.Error:
                                    console.error(message);
                                    return;
                                case LogLevel.Warning:
                                    console.warn(message);
                                    return;
                            }
                        },
                        piiLoggingEnabled: false
                    };
                }
                return msalConfig;
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                return _async_to_generator(function() {
                    var config, _, authContext, username, tenantId, localAccountId, account, e, error, accountType;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                config = this.getMsalConfig(false);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                _ = this;
                                return [
                                    4,
                                    AsyncTimer.executeWithTimeout(1500, function() {
                                        return createNestablePublicClientApplication(config);
                                    })
                                ];
                            case 2:
                                _.clientApp = _state.sent();
                                return [
                                    4,
                                    Office.auth.getAuthContext()
                                ];
                            case 3:
                                authContext = _state.sent();
                                username = authContext.userPrincipalName;
                                tenantId = authContext.tenantId;
                                localAccountId = authContext.userObjectId;
                                this.loginHint = authContext.loginHint || authContext.userPrincipalName;
                                account = this.clientApp.getAccount({
                                    username: username,
                                    localAccountId: localAccountId,
                                    tenantId: tenantId
                                });
                                if (account) {
                                    this.account = account;
                                }
                                return [
                                    4,
                                    this.ssoGetUserIdentity([
                                        "Mail.Read"
                                    ])
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                error = (_instanceof(e, TimeoutError) ? "Timed out creating the public NAA client app" : "Failed to initialize application") + ", reverting to legacy reporting flow";
                                JSLog.error(error, e);
                                console.log(error);
                                throw new InvalidStateError(error);
                            case 6:
                                if (!this.loginHint) {
                                    accountType = Office.context.mailbox.userProfile.accountType;
                                    this.loginHint = accountType === "office365" || accountType === "outlookCom" ? Office.context.mailbox.userProfile.emailAddress : "";
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "ssoGetToken",
            value: function ssoGetToken(scopes) {
                return _async_to_generator(function() {
                    var userAccount;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.ssoGetUserIdentity(scopes)
                                ];
                            case 1:
                                userAccount = _state.sent();
                                return [
                                    2,
                                    userAccount.accessToken
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getCachedToken",
            value: function getCachedToken(scopes) {
                return _async_to_generator(function() {
                    var scopeList;
                    return _ts_generator(this, function(_state) {
                        if (this.clientApp === void 0) {
                            throw new InvalidStateError("AccountManager is not initialized");
                        }
                        scopes.sort();
                        scopeList = scopes.join("; ");
                        if (this.tokens[scopeList]) {
                            console.log("Reusing cached token for scopes: " + scopeList);
                            return [
                                2,
                                this.tokens[scopeList].accessToken
                            ];
                        } else {
                            return [
                                2,
                                void 0
                            ];
                        }
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "ssoGetUserIdentity",
            value: function ssoGetUserIdentity(scopes) {
                return _async_to_generator(function() {
                    var scopeList, tokenRequest, authResult, _tmp, error, eMsg, interactiveErrorCodes, authResult1, error2, eMsg2;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.clientApp === void 0) {
                                    throw new InvalidStateError("AccountManager is not initialized");
                                }
                                scopes.sort();
                                scopeList = scopes.join("; ");
                                tokenRequest = {
                                    scopes: scopes,
                                    loginHint: this.loginHint,
                                    account: this.account,
                                    claims: void 0
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    14
                                ]);
                                if (!this.account) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.clientApp.acquireTokenSilent(tokenRequest)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    this.clientApp.ssoSilent(tokenRequest)
                                ];
                            case 4:
                                _tmp = _state.sent();
                                _state.label = 5;
                            case 5:
                                authResult = _tmp;
                                this.account = authResult.account;
                                this.tokens[scopeList] = authResult;
                                console.log("Acquired token silently.");
                                return [
                                    2,
                                    authResult
                                ];
                            case 6:
                                error = _state.sent();
                                eMsg = "Unable to acquire token silently: ".concat(error);
                                JSLog.error(eMsg, error);
                                console.log(eMsg);
                                interactiveErrorCodes = [
                                    "no_tokens_found",
                                    "native_account_unavailable",
                                    "refresh_token_expired",
                                    "interaction_required",
                                    "login_required",
                                    "bad_token",
                                    "monitor_window_timeout"
                                ];
                                if (!(error.errorCode === "consent_required")) return [
                                    3,
                                    7
                                ];
                                throw new InvalidStateError("Consent is not granted: ".concat(error));
                            case 7:
                                if (!(interactiveErrorCodes.indexOf(error.errorCode) > -1)) return [
                                    3,
                                    12
                                ];
                                _state.label = 8;
                            case 8:
                                _state.trys.push([
                                    8,
                                    10,
                                    ,
                                    11
                                ]);
                                if (error.claims) {
                                    console.log("Error type ".concat(error.errorCode, " contained conditional access claims: ").concat(error.claims));
                                    tokenRequest.claims = error.claims;
                                }
                                return [
                                    4,
                                    this.clientApp.acquireTokenPopup(tokenRequest)
                                ];
                            case 9:
                                authResult1 = _state.sent();
                                this.account = authResult1.account;
                                this.tokens[scopeList] = authResult1;
                                console.log("Acquired token interactively.");
                                return [
                                    2,
                                    authResult1
                                ];
                            case 10:
                                error2 = _state.sent();
                                eMsg2 = "Unable to acquire token interactively: ".concat(error2);
                                JSLog.error(eMsg2, error2);
                                console.log(eMsg2);
                                throw new InvalidStateError("Unable to acquire access token: ".concat(error2));
                            case 11:
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                throw new InvalidStateError("Unable to acquire access token: ".concat(error));
                            case 13:
                                return [
                                    3,
                                    14
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return AccountManager;
}();
// src/ErrorMessaging.ts
var ErrorMessaging = /*#__PURE__*/ function() {
    "use strict";
    function ErrorMessaging() {
        _class_call_check(this, ErrorMessaging);
    }
    _create_class(ErrorMessaging, [
        {
            key: "handleOfficeError",
            value: function handleOfficeError(result) {
                var error = this.formatOfficeError(result.error);
                console.log(error);
            }
        },
        {
            // TODO: ensure all errors passed to this are actually office errors, seems some of them are non-errors or jQuery objects
            key: "formatOfficeError",
            value: function formatOfficeError(error) {
                return error ? error.name + ": " + error.code + " - " + error.message : "Office async result did not succeed but did not return an error.";
            }
        }
    ]);
    return ErrorMessaging;
}();
// src/SharedMailboxHelpers.ts
var SharedMailboxData = function SharedMailboxData() {
    "use strict";
    _class_call_check(this, SharedMailboxData);
    this.targetRestUrl = null;
    this.targetMailbox = null;
    this.owner = null;
    this.sharedBox = false;
};
var SharedMailboxHelpers = /*#__PURE__*/ function() {
    "use strict";
    function SharedMailboxHelpers(errorMessaging) {
        _class_call_check(this, SharedMailboxHelpers);
        this.errorMessaging = errorMessaging;
    }
    _create_class(SharedMailboxHelpers, [
        {
            /**
   * Modern Promisified version of checking the shared mail box information
   * 
   * @returns A promise containing the shared mailbox information
   */ key: "getSharedMailboxInfoAsync",
            value: function getSharedMailboxInfoAsync() {
                var _mailbox_item;
                var mailbox = Office.context.mailbox;
                if (typeof ((_mailbox_item = mailbox.item) === null || _mailbox_item === void 0 ? void 0 : _mailbox_item.getSharedPropertiesAsync) === "function") {
                    return this.getSharedMailboxAsync();
                } else {
                    var _mailbox_item1;
                    console.log("mailbox.item.getSharedPropertiesAsync was " + _type_of((_mailbox_item1 = mailbox.item) === null || _mailbox_item1 === void 0 ? void 0 : _mailbox_item1.getSharedPropertiesAsync));
                    return Promise.resolve(new SharedMailboxData());
                }
            }
        },
        {
            key: "getSharedMailboxAsync",
            value: function getSharedMailboxAsync() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    var _mailbox_item;
                    var mailbox = Office.context.mailbox;
                    var sharedMailboxData = new SharedMailboxData();
                    (_mailbox_item = mailbox.item) === null || _mailbox_item === void 0 ? void 0 : _mailbox_item.getSharedPropertiesAsync(function(response) {
                        if (response.status === Office.AsyncResultStatus.Succeeded) {
                            console.log("Getting properties for an email in a shared folder.");
                            if (Office.context.requirements.isSetSupported("Mailbox", "1.8")) {
                                sharedMailboxData.targetRestUrl = response.value.targetRestUrl;
                                sharedMailboxData.targetMailbox = response.value.targetMailbox;
                                sharedMailboxData.owner = response.value.owner;
                                sharedMailboxData.sharedBox = true;
                                resolve(sharedMailboxData);
                            } else {
                                _this.errorMessaging.showErrorMessage("Outlook client does not support 1.8 requirement set.");
                                reject("Outlook client does not support 1.8 requirement set.");
                            }
                        } else {
                            _this.errorMessaging.handleOfficeError(response);
                            _this.errorMessaging.showErrorMessage("Outlook does not support this operation.");
                            reject("Outlook does not support this operation.");
                        }
                    });
                });
            }
        }
    ]);
    return SharedMailboxHelpers;
}();
// src/GraphHelpers.ts
var helpers = new Helpers();
var EmailGraphRequestType = /* @__PURE__ */ function(EmailGraphRequestType2) {
    EmailGraphRequestType2[EmailGraphRequestType2["Mime"] = 1] = "Mime";
    EmailGraphRequestType2[EmailGraphRequestType2["Headers"] = 2] = "Headers";
    EmailGraphRequestType2[EmailGraphRequestType2["IdOnly"] = 3] = "IdOnly";
    EmailGraphRequestType2[EmailGraphRequestType2["Attachments"] = 4] = "Attachments";
    EmailGraphRequestType2[EmailGraphRequestType2["Full"] = 5] = "Full";
    return EmailGraphRequestType2;
}(EmailGraphRequestType || {});
var Graph = /*#__PURE__*/ function() {
    "use strict";
    function Graph(opts) {
        _class_call_check(this, Graph);
        this.baseUrl = opts.baseUrl || "https://graph.microsoft.com/v1.0";
        this.emailAddress = opts.emailAddress;
        this.accountManager = new AccountManager(opts.appId, opts.authority);
        this.sharedMailboxHelpers = new SharedMailboxHelpers(opts.errorMessaging);
    }
    _create_class(Graph, [
        {
            key: "initialize",
            value: function initialize() {
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.accountManager.initialize()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "makeGraphJsonRequest",
            value: /**
   * Helper function to make a Microsoft Graph request to the specified path
   * 
   * @param accessToken The token retrieved from the account manager to make requests with the specified scopes
   * @param graphPath The route to the graph resource (e.g: /me/messages)
   * @param [queryParams=''] Optional parameter to specify query params for the end of the path
   * @returns Promise of the json result of the graph request
   * 
   * @throws {Error} response from the http fetch call.
   */ function makeGraphJsonRequest(accessToken, graphPath) {
                var queryParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                return _async_to_generator(function() {
                    var response, _, _tmp;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.makeRequest(accessToken, graphPath, queryParams)
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                _ = GraphResponseError.bind;
                                _tmp = [
                                    void 0,
                                    response,
                                    "Error making graph json request at ".concat(graphPath)
                                ];
                                return [
                                    4,
                                    this.tryGetResponseText(response)
                                ];
                            case 4:
                                throw new (_.apply(GraphResponseError, _tmp.concat([
                                    _state.sent()
                                ])));
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "makeGraphValueRequest",
            value: /**
   * Helper function to make a Microsoft Graph request to the specified path
   * 
   * @param accessToken The token retrieved from the account manager to make requests with the specified scopes
   * @param graphPath The route to the graph resource (e.g: /me/messages)
   * @param [queryParams=''] Optional parameter to specify query params for the end of the path
   * @returns Promise of the string result of the graph request
   * 
   * @throws {Error} response from the http fetch call.
   */ function makeGraphValueRequest(accessToken, graphPath) {
                var queryParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                return _async_to_generator(function() {
                    var response, _, _tmp;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.makeRequest(accessToken, graphPath, queryParams)
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.text()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                _ = GraphResponseError.bind;
                                _tmp = [
                                    void 0,
                                    response,
                                    "Error making graph value request at ".concat(graphPath)
                                ];
                                return [
                                    4,
                                    this.tryGetResponseText(response)
                                ];
                            case 4:
                                throw new (_.apply(GraphResponseError, _tmp.concat([
                                    _state.sent()
                                ])));
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "fetchEmailData",
            value: /**
   * Helper function to fetch data of the currently selected email.
   * Looks to see if the currently select mail item is from a user's mailbox 
   * or a shared mailbox.
   * 
   * @param dataType Enum to determine what type of data to return (Headers or Mime currently) 
   * @returns Promise of the mime document as a string 
   */ function fetchEmailData(dataType) {
                return _async_to_generator(function() {
                    var _this;
                    return _ts_generator(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.sharedMailboxHelpers.getSharedMailboxInfoAsync().then(function(data) {
                                return _async_to_generator(function() {
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    this.makeEmailGraphRequest(data, dataType)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }).call(_this);
                            }, function(error) {
                                JSLog.error("Mime document could not be retrieved", error);
                                throw error;
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "fetchEmailJsonData",
            value: function fetchEmailJsonData(dataType) {
                return _async_to_generator(function() {
                    var _this;
                    return _ts_generator(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.sharedMailboxHelpers.getSharedMailboxInfoAsync().then(function(data) {
                                return _async_to_generator(function() {
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    this.makeEmailGraphJsonRequest(data, dataType)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }).call(_this);
                            }, function(_) {
                                JSLog.error("Mime document could not be retrieved");
                                throw new Error("Mime document could not be retrieved");
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "moveEmail",
            value: /**
   * Helper function to move the currently selected email.
   * Looks to see if the currently select mail item is from a user's mailbox 
   * or a shared mailbox.
   *  
   * @returns Promise of the result as a string
   */ function moveEmail(destination) {
                return _async_to_generator(function() {
                    var _this;
                    return _ts_generator(this, function(_state) {
                        _this = this;
                        if (destination === "Nothing") {
                            return [
                                2,
                                Promise.resolve("No Move action specified")
                            ];
                        }
                        return [
                            2,
                            this.sharedMailboxHelpers.getSharedMailboxInfoAsync().then(function(data) {
                                return _async_to_generator(function() {
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    this.moveEmailRequest(data, destination)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }).call(_this);
                            }, function(error) {
                                JSLog.error("Error moving email.", error);
                                throw error;
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "moveEmailRequest",
            value: /**
   * Makes the graph call for a move request of the selected email
   */ function moveEmailRequest(mailboxData, destination) {
                return _async_to_generator(function() {
                    var _Office_context_mailbox_item, scopes, emailAddress, dest, id, path, cachedToken, response2, token, response, _, _tmp;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                emailAddress = "";
                                dest = "";
                                id = (_Office_context_mailbox_item = Office.context.mailbox.item) === null || _Office_context_mailbox_item === void 0 ? void 0 : _Office_context_mailbox_item.itemId.replaceAll("/", "-");
                                if (mailboxData && mailboxData.sharedBox && mailboxData.targetMailbox) {
                                    scopes = [
                                        "Mail.ReadWrite.Shared"
                                    ];
                                    emailAddress = mailboxData.targetMailbox;
                                } else {
                                    scopes = [
                                        "Mail.ReadWrite"
                                    ];
                                    emailAddress = this.emailAddress;
                                }
                                if ((destination === null || destination === void 0 ? void 0 : destination.toLowerCase()) === "junk") {
                                    dest = "junkemail";
                                } else if ((destination === null || destination === void 0 ? void 0 : destination.toLowerCase()) === "delete") {
                                    dest = "deleteditems";
                                } else {
                                    JSLog.warn("Invalid Move Location for post report action");
                                    return [
                                        2,
                                        Promise.resolve("")
                                    ];
                                }
                                path = "users/".concat(emailAddress, "/messages/").concat(id, "/move");
                                return [
                                    4,
                                    this.accountManager.getCachedToken(scopes)
                                ];
                            case 1:
                                cachedToken = _state.sent();
                                if (!cachedToken) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.postRequest(cachedToken, path, {
                                        destinationId: dest
                                    })
                                ];
                            case 2:
                                response2 = _state.sent();
                                if (!response2.ok) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    response2.text()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                console.log("Error making graph request with cached token", response2);
                                _state.label = 5;
                            case 5:
                                return [
                                    4,
                                    this.accountManager.ssoGetToken(scopes)
                                ];
                            case 6:
                                token = _state.sent();
                                return [
                                    4,
                                    this.postRequest(token, path, {
                                        destinationId: dest
                                    })
                                ];
                            case 7:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    response.text()
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 9:
                                _ = GraphResponseError.bind;
                                _tmp = [
                                    void 0,
                                    response,
                                    "Error making move email request to ".concat(destination)
                                ];
                                return [
                                    4,
                                    this.tryGetResponseText(response)
                                ];
                            case 10:
                                throw new (_.apply(GraphResponseError, _tmp.concat([
                                    _state.sent()
                                ])));
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "makeEmailGraphRequest",
            value: /**
   * Makes the graph call to fetch the mime document for the selected email
   */ function makeEmailGraphRequest(mailboxData, type) {
                return _async_to_generator(function() {
                    var _Office_context_mailbox_item, scopes, emailAddress, path, queryParams, id, cachedToken, emailData2, error, token, emailData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                emailAddress = "";
                                path = "";
                                queryParams = "";
                                id = (_Office_context_mailbox_item = Office.context.mailbox.item) === null || _Office_context_mailbox_item === void 0 ? void 0 : _Office_context_mailbox_item.itemId.replaceAll("/", "-");
                                if (mailboxData && mailboxData.sharedBox && mailboxData.targetMailbox) {
                                    scopes = [
                                        "Mail.Read.Shared"
                                    ];
                                    emailAddress = mailboxData.targetMailbox;
                                } else {
                                    scopes = [
                                        "Mail.Read"
                                    ];
                                    emailAddress = this.emailAddress;
                                }
                                switch(type){
                                    case 2 /* Headers */ :
                                        path = "users/".concat(emailAddress, "/messages/").concat(id, "/");
                                        queryParams = "?$select=internetMessageHeaders";
                                        break;
                                    case 1 /* Mime */ :
                                        path = "users/".concat(emailAddress, "/messages/").concat(id, "/$value");
                                        break;
                                    case 3 /* IdOnly */ :
                                        path = "users/".concat(emailAddress, "/messages/").concat(id);
                                        queryParams = "?$select=id";
                                        break;
                                    case 5 /* Full */ :
                                        path = "users/".concat(emailAddress, "/messages/").concat(id);
                                        break;
                                }
                                return [
                                    4,
                                    this.accountManager.getCachedToken(scopes)
                                ];
                            case 1:
                                cachedToken = _state.sent();
                                if (!cachedToken) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.makeGraphValueRequest(cachedToken, path, queryParams)
                                ];
                            case 3:
                                emailData2 = _state.sent();
                                return [
                                    2,
                                    emailData2
                                ];
                            case 4:
                                error = _state.sent();
                                console.log("Error making graph request with cached token", error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    4,
                                    this.accountManager.ssoGetToken(scopes)
                                ];
                            case 6:
                                token = _state.sent();
                                return [
                                    4,
                                    this.makeGraphValueRequest(token, path, queryParams)
                                ];
                            case 7:
                                emailData = _state.sent();
                                return [
                                    2,
                                    emailData
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "makeEmailGraphJsonRequest",
            value: /**
  * Makes the graph call to fetch the mime document for the selected email
  */ function makeEmailGraphJsonRequest(mailboxData, type) {
                return _async_to_generator(function() {
                    var _Office_context_mailbox_item, scopes, emailAddress, path, queryParams, id, cachedToken, emailData2, error, token, emailData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                emailAddress = "";
                                path = "";
                                queryParams = "";
                                id = (_Office_context_mailbox_item = Office.context.mailbox.item) === null || _Office_context_mailbox_item === void 0 ? void 0 : _Office_context_mailbox_item.itemId.replaceAll("/", "-");
                                if (mailboxData && mailboxData.sharedBox && mailboxData.targetMailbox) {
                                    scopes = [
                                        "Mail.Read.Shared"
                                    ];
                                    emailAddress = mailboxData.targetMailbox;
                                } else {
                                    scopes = [
                                        "Mail.Read"
                                    ];
                                    emailAddress = this.emailAddress;
                                }
                                switch(type){
                                    case 4 /* Attachments */ :
                                        path = "users/".concat(emailAddress, "/messages/").concat(id, "/attachments");
                                        break;
                                    case 5 /* Full */ :
                                        path = "users/".concat(emailAddress, "/messages/").concat(id);
                                        break;
                                }
                                return [
                                    4,
                                    this.accountManager.getCachedToken(scopes)
                                ];
                            case 1:
                                cachedToken = _state.sent();
                                if (!cachedToken) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.makeGraphJsonRequest(cachedToken, path, queryParams)
                                ];
                            case 3:
                                emailData2 = _state.sent();
                                return [
                                    2,
                                    emailData2
                                ];
                            case 4:
                                error = _state.sent();
                                console.log("Error making graph request with cached token", error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    4,
                                    this.accountManager.ssoGetToken(scopes)
                                ];
                            case 6:
                                token = _state.sent();
                                return [
                                    4,
                                    this.makeGraphJsonRequest(token, path, queryParams)
                                ];
                            case 7:
                                emailData = _state.sent();
                                return [
                                    2,
                                    emailData
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "sendEmailRequest",
            value: /**
   * Helper function to send the post report email to the reporter.
   * 
   * @returns Promise of the result of the send operation.
   */ function sendEmailRequest(postReportData, headers, originalMimeEmail) {
                return _async_to_generator(function() {
                    var emailToSend, url, cachedToken, response2, token, response, _, _tmp, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    13,
                                    ,
                                    14
                                ]);
                                return [
                                    4,
                                    this.buildForwardEmail(postReportData, headers, originalMimeEmail)
                                ];
                            case 1:
                                emailToSend = _state.sent();
                                url = "users/".concat(this.emailAddress, "/sendMail");
                                return [
                                    4,
                                    this.accountManager.getCachedToken([
                                        "Mail.Send"
                                    ])
                                ];
                            case 2:
                                cachedToken = _state.sent();
                                if (!cachedToken) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this.postRequest(cachedToken, url, emailToSend)
                                ];
                            case 3:
                                response2 = _state.sent();
                                if (!response2.ok) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    response2.text()
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                console.log("Error making graph request with cached token", response2);
                                _state.label = 6;
                            case 6:
                                return [
                                    4,
                                    this.accountManager.ssoGetToken([
                                        "Mail.Send"
                                    ])
                                ];
                            case 7:
                                token = _state.sent();
                                return [
                                    4,
                                    this.postRequest(token, url, emailToSend)
                                ];
                            case 8:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    response.text()
                                ];
                            case 9:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 10:
                                _ = GraphResponseError.bind;
                                _tmp = [
                                    void 0,
                                    response,
                                    "Error making graph send email request at ".concat(url)
                                ];
                                return [
                                    4,
                                    this.tryGetResponseText(response)
                                ];
                            case 11:
                                throw new (_.apply(GraphResponseError, _tmp.concat([
                                    _state.sent()
                                ])));
                            case 12:
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                error = _state.sent();
                                JSLog.error(error);
                                throw error;
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "buildForwardEmail",
            value: // extracted out for easier unit testing
            function buildForwardEmail(postReportData, headers, originalMimeEmail) {
                return _async_to_generator(function() {
                    var _Office_context_mailbox_item, emailToSend, _attachmentList_value, attachmentList, graphHeaders;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                emailToSend = {
                                    message: {
                                        subject: postReportData.subject,
                                        body: {
                                            contentType: "html",
                                            content: postReportData.body
                                        },
                                        toRecipients: [],
                                        attachments: [],
                                        singleValueExtendedProperties: [
                                            {
                                                id: "String 0x1042",
                                                //PR_IN_REPLY_TO_ID to set In-Reply-To header
                                                value: (_Office_context_mailbox_item = Office.context.mailbox.item) === null || _Office_context_mailbox_item === void 0 ? void 0 : _Office_context_mailbox_item.internetMessageId
                                            }
                                        ]
                                    },
                                    saveToSentItems: true
                                };
                                postReportData.recipients.forEach(function(val) {
                                    emailToSend.message.toRecipients.push({
                                        emailAddress: {
                                            address: val
                                        }
                                    });
                                });
                                if (!postReportData.attachments) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.fetchEmailJsonData(4 /* Attachments */ )
                                ];
                            case 1:
                                attachmentList = _state.sent();
                                if ((attachmentList === null || attachmentList === void 0 ? void 0 : (_attachmentList_value = attachmentList.value) === null || _attachmentList_value === void 0 ? void 0 : _attachmentList_value.length) > 0) {
                                    attachmentList.value.forEach(function(att) {
                                        if (!att.isInline) {
                                            emailToSend.message.attachments.push({
                                                "@odata.type": "#microsoft.graph.fileAttachment",
                                                name: att.name,
                                                contentType: att.contentType,
                                                contentBytes: att.contentBytes
                                            });
                                        }
                                    });
                                }
                                _state.label = 2;
                            case 2:
                                if (postReportData.originalEmailAsAttachment) {
                                    emailToSend.message.attachments.push({
                                        "@odata.type": "#microsoft.graph.fileAttachment",
                                        name: "".concat(postReportData.subject, ".eml"),
                                        contentType: "message/rfc822",
                                        contentBytes: helpers.encodeToBase64(originalMimeEmail)
                                    });
                                }
                                return [
                                    4,
                                    this.buildHeaderAttachment(headers)
                                ];
                            case 3:
                                graphHeaders = _state.sent();
                                emailToSend.message.attachments.push({
                                    "@odata.type": "#microsoft.graph.fileAttachment",
                                    name: "Headers.txt",
                                    contentType: "text/plain",
                                    contentBytes: helpers.encodeToBase64(graphHeaders)
                                });
                                return [
                                    2,
                                    emailToSend
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "makeRequest",
            value: function makeRequest(accessToken, graphPath) {
                var queryParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                return _async_to_generator(function() {
                    var url, response;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = this.validateAndFormatUrl(graphPath, queryParams);
                                return [
                                    4,
                                    fetch(url, {
                                        headers: {
                                            Authorization: accessToken
                                        }
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "postRequest",
            value: function postRequest(_0, _1) {
                return _async_to_generator(function(accessToken, graphPath) {
                    var data, queryParams, url, response;
                    var _arguments = arguments;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {}, queryParams = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "";
                                url = this.validateAndFormatUrl(graphPath, queryParams);
                                return [
                                    4,
                                    fetch(url, {
                                        method: "POST",
                                        headers: {
                                            Authorization: accessToken,
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(data)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "validateAndFormatUrl",
            value: function validateAndFormatUrl(graphPath, queryParams) {
                if (!graphPath) {
                    throw new InvalidArgumentError("No path was specified for the graph request");
                }
                if (!graphPath.startsWith("/")) {
                    graphPath = "/".concat(graphPath);
                }
                if (queryParams && !queryParams.startsWith("?")) {
                    queryParams = "?".concat(queryParams);
                }
                return "".concat(this.baseUrl).concat(graphPath).concat(queryParams);
            }
        },
        {
            key: "tryGetResponseText",
            value: function tryGetResponseText(response) {
                return _async_to_generator(function() {
                    var error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    response.text()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                JSLog.error("Unable to read Graph response text", error);
                                return [
                                    2,
                                    ""
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildHeaderAttachment",
            value: function buildHeaderAttachment(headers) {
                return _async_to_generator(function() {
                    var parsedHeaders, headerString, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!(typeof headers === "string" && headers.length > 0)) return [
                                    3,
                                    1
                                ];
                                return [
                                    2,
                                    Promise.resolve(headers)
                                ];
                            case 1:
                                return [
                                    4,
                                    this.fetchEmailData(2 /* Headers */ )
                                ];
                            case 2:
                                headers = _state.sent();
                                parsedHeaders = JSON.parse(headers);
                                headerString = "";
                                if (!parsedHeaders || !parsedHeaders.internetMessageHeaders) {
                                    throw new Error("Invalid header format");
                                }
                                parsedHeaders.internetMessageHeaders.forEach(function(val) {
                                    headerString += "".concat(val.name, ": ").concat(val.value, "\r\n");
                                });
                                return [
                                    2,
                                    Promise.resolve(headerString)
                                ];
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                JSLog.error(error);
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return Graph;
}();
// src/Polyfills.ts
function fillURL() {
    var fn = Helpers.isIE11 ? function URL(url) {
        var slashIndex = url.indexOf("/", url.indexOf("//") + 2);
        this.href = url + (slashIndex === -1 ? "/" : "");
    } : window.URL;
    Object.defineProperty(fn.prototype, "origin", {
        get: function get() {
            return this.href.substring(0, this.href.indexOf("/", 8));
        }
    });
    Object.defineProperty(fn.prototype, "host", {
        get: function get() {
            return this.href.substring(this.href.indexOf("//") + 2, this.href.indexOf("/", 8));
        }
    });
    Object.defineProperty(fn.prototype, "hostname", {
        get: function get() {
            var hostPortIndex = this.host.indexOf(":");
            return hostPortIndex > 0 ? this.host.substring(0, hostPortIndex) : this.host;
        }
    });
    Object.defineProperty(fn.prototype, "port", {
        get: function get() {
            var hostPortIndex = this.host.indexOf(":");
            return hostPortIndex > 0 ? this.host.substring(hostPortIndex + 1) : "";
        }
    });
    Object.defineProperty(fn.prototype, "protocol", {
        get: function get() {
            return this.href.substring(0, this.href.indexOf("//"));
        }
    });
    Object.defineProperty(fn.prototype, "pathname", {
        get: function get() {
            var slashIndex = this.href.indexOf("/", this.href.indexOf("//") + 2);
            var questionIndex = this.href.indexOf("?", slashIndex);
            return this.href.substring(slashIndex, questionIndex > 0 ? questionIndex : this.href.length);
        }
    });
    Object.defineProperty(fn.prototype, "search", {
        get: function get() {
            var questionIndex = this.href.indexOf("?");
            return questionIndex > 0 ? this.href.substring(questionIndex) : "";
        }
    });
    if (Helpers.isIE11) {
        Object.defineProperty(fn.prototype, "searchParams", {
            get: function get() {
                var questionIndex = this.href.indexOf("?");
                var search = questionIndex > 0 ? this.href.substring(questionIndex + 1) : "";
                if (search) {
                    var params = new URLSearchParams();
                    search.split("&").forEach(function(pair) {
                        var _pair_split = _sliced_to_array(pair.split("="), 2), key = _pair_split[0], value = _pair_split[1];
                        params.append(key, value);
                    });
                    return params;
                } else {
                    return new URLSearchParams("");
                }
            }
        });
        window.URL = fn;
    }
}
// src/Requests.ts
var AlarmReportSource = /* @__PURE__ */ function(AlarmReportSource2) {
    AlarmReportSource2[AlarmReportSource2["None"] = 0] = "None";
    AlarmReportSource2[AlarmReportSource2["Ewt"] = 1] = "Ewt";
    AlarmReportSource2[AlarmReportSource2["Exchange"] = 2] = "Exchange";
    AlarmReportSource2[AlarmReportSource2["Outlook"] = 3] = "Outlook";
    AlarmReportSource2[AlarmReportSource2["Gmail"] = 4] = "Gmail";
    AlarmReportSource2[AlarmReportSource2["IntegratedSpamReport"] = 5] = "IntegratedSpamReport";
    return AlarmReportSource2;
}(AlarmReportSource || {});
var ReportEmailRequest = function ReportEmailRequest(init) {
    "use strict";
    _class_call_check(this, ReportEmailRequest);
    Object.assign(this, init);
};
export { AccountManager, AlarmReportSource, AsyncTimer, EmailGraphRequestType, ErrorCodesEnum, ErrorMessaging, Graph, GraphResponseError, Helpers, InvalidArgumentError, InvalidStateError, JSLog, ReportEmailRequest, SharedMailboxData, SharedMailboxHelpers, TimeoutError, cleanStackTrace, fillURL, parseStackTrace };
//# sourceMappingURL=index.mjs.map